// object to store loaded and loading wasm modules
var installedWasmModules = {};

function promiseResolve() { return Promise.resolve(); }

var wasmImportedFuncCache0;
var wasmImportedFuncCache1;
var wasmImportedFuncCache2;
var wasmImportedFuncCache3;
var wasmImportedFuncCache4;
var wasmImportedFuncCache5;
var wasmImportedFuncCache6;
var wasmImportedFuncCache7;
var wasmImportedFuncCache8;
var wasmImportedFuncCache9;
var wasmImportedFuncCache10;
var wasmImportedFuncCache11;
var wasmImportedFuncCache12;
var wasmImportedFuncCache13;
var wasmImportedFuncCache14;
var wasmImportedFuncCache15;
var wasmImportedFuncCache16;
var wasmImportedFuncCache17;
var wasmImportedFuncCache18;
var wasmImportedFuncCache19;
var wasmImportedFuncCache20;
var wasmImportedFuncCache21;
var wasmImportedFuncCache22;
var wasmImportedFuncCache23;
var wasmImportedFuncCache24;
var wasmImportedFuncCache25;
var wasmImportedFuncCache26;
var wasmImportedFuncCache27;
var wasmImportedFuncCache28;
var wasmImportedFuncCache29;
var wasmImportedFuncCache30;
var wasmImportedFuncCache31;
var wasmImportedFuncCache32;
var wasmImportedFuncCache33;
var wasmImportedFuncCache34;
var wasmImportedFuncCache35;
var wasmImportedFuncCache36;
var wasmImportedFuncCache37;
var wasmImportedFuncCache38;
var wasmImportedFuncCache39;
var wasmImportedFuncCache40;
var wasmImportedFuncCache41;
var wasmImportedFuncCache42;
var wasmImportedFuncCache43;
var wasmImportedFuncCache44;
var wasmImportedFuncCache45;
var wasmImportedFuncCache46;
var wasmImportedFuncCache47;
var wasmImportedFuncCache48;
var wasmImportedFuncCache49;
var wasmImportedFuncCache50;
var wasmImportedFuncCache51;
var wasmImportedFuncCache52;
var wasmImportedFuncCache53;
var wasmImportedFuncCache54;
var wasmImportedFuncCache55;
var wasmImportedFuncCache56;
var wasmImportedFuncCache57;
var wasmImportedFuncCache58;
var wasmImportedFuncCache59;
var wasmImportedFuncCache60;
var wasmImportedFuncCache61;
var wasmImportedFuncCache62;
var wasmImportedFuncCache63;
var wasmImportedFuncCache64;
var wasmImportedFuncCache65;
var wasmImportedFuncCache66;
var wasmImportedFuncCache67;
var wasmImportedFuncCache68;
var wasmImportedFuncCache69;
var wasmImportedFuncCache70;
var wasmImportedFuncCache71;
var wasmImportedFuncCache72;
var wasmImportObjects = {
	70562: function() {
		return {
			"./midi_bg.js": {
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache0 === undefined) wasmImportedFuncCache0 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache0["bk"](p0i32);
				},
				"__wbindgen_number_get": function(p0i32,p1i32) {
					if(wasmImportedFuncCache1 === undefined) wasmImportedFuncCache1 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache1["sW"](p0i32,p1i32);
				},
				"__wbindgen_number_new": function(p0f64) {
					if(wasmImportedFuncCache2 === undefined) wasmImportedFuncCache2 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache2["QR"](p0f64);
				},
				"__wbindgen_string_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache3 === undefined) wasmImportedFuncCache3 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache3["yc"](p0i32,p1i32);
				},
				"__wbg_log_151eb4333ef0fe39": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache4 === undefined) wasmImportedFuncCache4 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache4["uI"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_info_80803d9a3f0aad16": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache5 === undefined) wasmImportedFuncCache5 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache5["a0"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_warn_5d3f783b0bae8943": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache6 === undefined) wasmImportedFuncCache6 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache6["f1"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_debug_7d879afce6cf56cb": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache7 === undefined) wasmImportedFuncCache7 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache7["FT"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_error_8e3928cfb8a43e2b": function(p0i32) {
					if(wasmImportedFuncCache8 === undefined) wasmImportedFuncCache8 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache8["mS"](p0i32);
				},
				"__wbg_error_696630710900ec44": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache9 === undefined) wasmImportedFuncCache9 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache9["_J"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_new_abda76e883ba8a5f": function() {
					if(wasmImportedFuncCache10 === undefined) wasmImportedFuncCache10 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache10["V5"]();
				},
				"__wbg_stack_658279fe44541cf6": function(p0i32,p1i32) {
					if(wasmImportedFuncCache11 === undefined) wasmImportedFuncCache11 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache11["u$"](p0i32,p1i32);
				},
				"__wbg_error_f851667af71bcfc6": function(p0i32,p1i32) {
					if(wasmImportedFuncCache12 === undefined) wasmImportedFuncCache12 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache12["Xu"](p0i32,p1i32);
				},
				"__wbg_queueMicrotask_3cbae2ec6b6cd3d6": function(p0i32) {
					if(wasmImportedFuncCache13 === undefined) wasmImportedFuncCache13 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache13["Fq"](p0i32);
				},
				"__wbindgen_is_function": function(p0i32) {
					if(wasmImportedFuncCache14 === undefined) wasmImportedFuncCache14 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache14["PR"](p0i32);
				},
				"__wbindgen_cb_drop": function(p0i32) {
					if(wasmImportedFuncCache15 === undefined) wasmImportedFuncCache15 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache15["LC"](p0i32);
				},
				"__wbg_queueMicrotask_481971b0d87f3dd4": function(p0i32) {
					if(wasmImportedFuncCache16 === undefined) wasmImportedFuncCache16 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache16["fi"](p0i32);
				},
				"__wbg_self_ce0dbfc45cf2f5be": function() {
					if(wasmImportedFuncCache17 === undefined) wasmImportedFuncCache17 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache17["cX"]();
				},
				"__wbg_window_c6fb939a7f436783": function() {
					if(wasmImportedFuncCache18 === undefined) wasmImportedFuncCache18 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache18["kh"]();
				},
				"__wbg_globalThis_d1e6af4856ba331b": function() {
					if(wasmImportedFuncCache19 === undefined) wasmImportedFuncCache19 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache19["Kc"]();
				},
				"__wbg_global_207b558942527489": function() {
					if(wasmImportedFuncCache20 === undefined) wasmImportedFuncCache20 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache20["vA"]();
				},
				"__wbindgen_is_undefined": function(p0i32) {
					if(wasmImportedFuncCache21 === undefined) wasmImportedFuncCache21 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache21["vU"](p0i32);
				},
				"__wbg_newnoargs_e258087cd0daa0ea": function(p0i32,p1i32) {
					if(wasmImportedFuncCache22 === undefined) wasmImportedFuncCache22 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache22["Pf"](p0i32,p1i32);
				},
				"__wbg_call_27c0f87801dedf93": function(p0i32,p1i32) {
					if(wasmImportedFuncCache23 === undefined) wasmImportedFuncCache23 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache23["cq"](p0i32,p1i32);
				},
				"__wbindgen_object_clone_ref": function(p0i32) {
					if(wasmImportedFuncCache24 === undefined) wasmImportedFuncCache24 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache24["BZ"](p0i32);
				},
				"__wbg_of_40f6b8e691c04867": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache25 === undefined) wasmImportedFuncCache25 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache25["Fg"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_apply_6d0b9cd50eb480c3": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache26 === undefined) wasmImportedFuncCache26 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache26["$b"](p0i32,p1i32,p2i32);
				},
				"__wbg_call_b3ca7c6051f9bec1": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache27 === undefined) wasmImportedFuncCache27 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache27["_m"](p0i32,p1i32,p2i32);
				},
				"__wbg_call_8e7cb608789c2528": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache28 === undefined) wasmImportedFuncCache28 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache28["eE"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_call_938992c832f74314": function(p0i32,p1i32,p2i32,p3i32,p4i32) {
					if(wasmImportedFuncCache29 === undefined) wasmImportedFuncCache29 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache29["gF"](p0i32,p1i32,p2i32,p3i32,p4i32);
				},
				"__wbg_new_81740750da40724f": function(p0i32,p1i32) {
					if(wasmImportedFuncCache30 === undefined) wasmImportedFuncCache30 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache30["lb"](p0i32,p1i32);
				},
				"__wbg_resolve_b0083a7967828ec8": function(p0i32) {
					if(wasmImportedFuncCache31 === undefined) wasmImportedFuncCache31 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache31["w"](p0i32);
				},
				"__wbg_then_0c86a60e8fcfe9f6": function(p0i32,p1i32) {
					if(wasmImportedFuncCache32 === undefined) wasmImportedFuncCache32 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache32["MG"](p0i32,p1i32);
				},
				"__wbg_then_a73caa9a87991566": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache33 === undefined) wasmImportedFuncCache33 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache33["bs"](p0i32,p1i32,p2i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache34 === undefined) wasmImportedFuncCache34 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache34["Qn"](p0i32,p1i32);
				},
				"__wbindgen_debug_string": function(p0i32,p1i32) {
					if(wasmImportedFuncCache35 === undefined) wasmImportedFuncCache35 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache35["rl"](p0i32,p1i32);
				},
				"__wbindgen_closure_wrapper272": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache36 === undefined) wasmImportedFuncCache36 = __webpack_require__.c[33659].exports;
					return wasmImportedFuncCache36["eY"](p0i32,p1i32,p2i32);
				}
			}
		};
	},
	6458: function() {
		return {
			"./spectrum_viz_bg.js": {
				"__wbindgen_string_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache37 === undefined) wasmImportedFuncCache37 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache37["yc"](p0i32,p1i32);
				},
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache38 === undefined) wasmImportedFuncCache38 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache38["bk"](p0i32);
				},
				"__wbg_log_151eb4333ef0fe39": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache39 === undefined) wasmImportedFuncCache39 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache39["uI"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_info_80803d9a3f0aad16": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache40 === undefined) wasmImportedFuncCache40 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache40["a0"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_warn_5d3f783b0bae8943": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache41 === undefined) wasmImportedFuncCache41 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache41["f1"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_debug_7d879afce6cf56cb": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache42 === undefined) wasmImportedFuncCache42 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache42["FT"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_error_8e3928cfb8a43e2b": function(p0i32) {
					if(wasmImportedFuncCache43 === undefined) wasmImportedFuncCache43 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache43["mS"](p0i32);
				},
				"__wbg_error_696630710900ec44": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache44 === undefined) wasmImportedFuncCache44 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache44["_J"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_new_abda76e883ba8a5f": function() {
					if(wasmImportedFuncCache45 === undefined) wasmImportedFuncCache45 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache45["V5"]();
				},
				"__wbg_stack_658279fe44541cf6": function(p0i32,p1i32) {
					if(wasmImportedFuncCache46 === undefined) wasmImportedFuncCache46 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache46["u$"](p0i32,p1i32);
				},
				"__wbg_error_f851667af71bcfc6": function(p0i32,p1i32) {
					if(wasmImportedFuncCache47 === undefined) wasmImportedFuncCache47 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache47["Xu"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache48 === undefined) wasmImportedFuncCache48 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache48["Qn"](p0i32,p1i32);
				}
			}
		};
	},
	6458: function() {
		return {
			"./spectrum_viz_bg.js": {
				"__wbindgen_string_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache49 === undefined) wasmImportedFuncCache49 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache49["yc"](p0i32,p1i32);
				},
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache50 === undefined) wasmImportedFuncCache50 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache50["bk"](p0i32);
				},
				"__wbg_log_151eb4333ef0fe39": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache51 === undefined) wasmImportedFuncCache51 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache51["uI"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_info_80803d9a3f0aad16": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache52 === undefined) wasmImportedFuncCache52 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache52["a0"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_warn_5d3f783b0bae8943": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache53 === undefined) wasmImportedFuncCache53 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache53["f1"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_debug_7d879afce6cf56cb": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache54 === undefined) wasmImportedFuncCache54 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache54["FT"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_error_8e3928cfb8a43e2b": function(p0i32) {
					if(wasmImportedFuncCache55 === undefined) wasmImportedFuncCache55 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache55["mS"](p0i32);
				},
				"__wbg_error_696630710900ec44": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache56 === undefined) wasmImportedFuncCache56 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache56["_J"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_new_abda76e883ba8a5f": function() {
					if(wasmImportedFuncCache57 === undefined) wasmImportedFuncCache57 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache57["V5"]();
				},
				"__wbg_stack_658279fe44541cf6": function(p0i32,p1i32) {
					if(wasmImportedFuncCache58 === undefined) wasmImportedFuncCache58 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache58["u$"](p0i32,p1i32);
				},
				"__wbg_error_f851667af71bcfc6": function(p0i32,p1i32) {
					if(wasmImportedFuncCache59 === undefined) wasmImportedFuncCache59 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache59["Xu"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache60 === undefined) wasmImportedFuncCache60 = __webpack_require__.c[45283].exports;
					return wasmImportedFuncCache60["Qn"](p0i32,p1i32);
				}
			}
		};
	},
	86864: function() {
		return {
			"./wav_decoder_bg.js": {
				"__wbindgen_string_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache61 === undefined) wasmImportedFuncCache61 = __webpack_require__.c[51065].exports;
					return wasmImportedFuncCache61["yc"](p0i32,p1i32);
				},
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache62 === undefined) wasmImportedFuncCache62 = __webpack_require__.c[51065].exports;
					return wasmImportedFuncCache62["bk"](p0i32);
				},
				"__wbg_log_151eb4333ef0fe39": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache63 === undefined) wasmImportedFuncCache63 = __webpack_require__.c[51065].exports;
					return wasmImportedFuncCache63["uI"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_info_80803d9a3f0aad16": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache64 === undefined) wasmImportedFuncCache64 = __webpack_require__.c[51065].exports;
					return wasmImportedFuncCache64["a0"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_warn_5d3f783b0bae8943": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache65 === undefined) wasmImportedFuncCache65 = __webpack_require__.c[51065].exports;
					return wasmImportedFuncCache65["f1"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_debug_7d879afce6cf56cb": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache66 === undefined) wasmImportedFuncCache66 = __webpack_require__.c[51065].exports;
					return wasmImportedFuncCache66["FT"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_error_8e3928cfb8a43e2b": function(p0i32) {
					if(wasmImportedFuncCache67 === undefined) wasmImportedFuncCache67 = __webpack_require__.c[51065].exports;
					return wasmImportedFuncCache67["mS"](p0i32);
				},
				"__wbg_error_696630710900ec44": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache68 === undefined) wasmImportedFuncCache68 = __webpack_require__.c[51065].exports;
					return wasmImportedFuncCache68["_J"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_new_abda76e883ba8a5f": function() {
					if(wasmImportedFuncCache69 === undefined) wasmImportedFuncCache69 = __webpack_require__.c[51065].exports;
					return wasmImportedFuncCache69["V5"]();
				},
				"__wbg_stack_658279fe44541cf6": function(p0i32,p1i32) {
					if(wasmImportedFuncCache70 === undefined) wasmImportedFuncCache70 = __webpack_require__.c[51065].exports;
					return wasmImportedFuncCache70["u$"](p0i32,p1i32);
				},
				"__wbg_error_f851667af71bcfc6": function(p0i32,p1i32) {
					if(wasmImportedFuncCache71 === undefined) wasmImportedFuncCache71 = __webpack_require__.c[51065].exports;
					return wasmImportedFuncCache71["Xu"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache72 === undefined) wasmImportedFuncCache72 = __webpack_require__.c[51065].exports;
					return wasmImportedFuncCache72["Qn"](p0i32,p1i32);
				}
			}
		};
	},
};

var wasmModuleMap = {
	"113": [
		6458
	],
	"458": [
		6458
	],
	"631": [
		86864
	],
	"985": [
		70562
	]
};

// object with all WebAssembly.instance exports
__webpack_require__.w = {};

// Fetch + compile chunk loading for webassembly
__webpack_require__.f.wasm = function(chunkId, promises) {

	var wasmModules = wasmModuleMap[chunkId] || [];

	wasmModules.forEach(function(wasmModuleId, idx) {
		var installedWasmModuleData = installedWasmModules[wasmModuleId];

		// a Promise means "currently loading" or "already loaded".
		if(installedWasmModuleData)
			promises.push(installedWasmModuleData);
		else {
			var importObject = wasmImportObjects[wasmModuleId]();
			var req = fetch(__webpack_require__.p + "" + {"113":{"6458":"8e9f7881736498868917"},"458":{"6458":"8e9f7881736498868917"},"631":{"86864":"58392c92a69432114c1d"},"985":{"70562":"7d22afe6f4c241d0bd14"}}[chunkId][wasmModuleId] + ".module.wasm");
			var promise;
			if(importObject && typeof importObject.then === 'function' && typeof WebAssembly.compileStreaming === 'function') {
				promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
					return WebAssembly.instantiate(items[0], items[1]);
				});
			} else if(typeof WebAssembly.instantiateStreaming === 'function') {
				promise = WebAssembly.instantiateStreaming(req, importObject);
			} else {
				var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
				promise = bytesPromise.then(function(bytes) {
					return WebAssembly.instantiate(bytes, importObject);
				});
			}
			promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
				return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
			}));
		}
	});
};